import { memo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { EnumType } from 'json-to-graphql-query';
import SMSCodeFields from './Fields';
import API from 'api';

function ConnectedSMSCodeFields(props) {
	const smsCode = useSelector(state => state.smsCode);
	const dispatch = useDispatch();

	const getSMSCode = (phone, scope, captcha, type) => {
		if (type === 'call') {
			return dispatch(API.mutations.sendPhoneCallVerificationCode({
				input: {
					phone,
					scope: new EnumType(scope),
					captcha
				}
			}));
		} else {
			return dispatch(API.mutations.sendSmsVerificationCode({
				input: {
					phone,
					scope: new EnumType(scope),
					captcha
				}
			}));
		}
	};

	const reset = () => {
		dispatch(API.queries.smsCode.reset());
	};

	return (
		<SMSCodeFields
			smsCode={smsCode}
			getSMSCode={getSMSCode}
			reset={reset}
			{...props}
		/>
	)
};

export default memo(ConnectedSMSCodeFields);